import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { history } from '../store'

import { updateRule, fetchRules, deleteRule } from '../actions/rules'

class RulesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ruleblockConfirmShown: false,
      ruleId: null,
      ruleActive: null,
    };

    this.updateRuleblock = this.updateRuleblock.bind(this)

    this.ruleblockConfirmShow = this.ruleblockConfirmShow.bind(this)
    this.ruleblockConfirmToggle = this.ruleblockConfirmToggle.bind(this)
  }

  goTo(id, e) {
    // In modal mode (onEdit provided) open the edit modal; otherwise fall back to the route
    if (this.props.onEdit) {
      this.props.onEdit(id)
    } else {
      history.push(`/rules/${id}/edit`)
    }
  }

  getTypeName(type) {
    switch (type) {
      case "MaxDayDiscount": return "Descuento por días"
      case "AlwaysDiscount": return "Descuento fijo"
      default: return "None"
    }
  }

  getLockerName(type) {
    switch (type) {
      case "ALL": return "TODAS"
      case "2PAX": return "2 Equipos de esquí"
      case "3PAX": return "3 Equipos de esquí"
      case "4PAX": return "4 Equipos de esquí"
      case "3PAXSS": return "3 Equipos sin secado"
      case "BNS": return "Standard"
      case "BNM": return "Medium"
      default: return "None"
    }
  }

  handleRuleblockClick = (rule, e) => {
    e.stopPropagation();
    this.ruleblockConfirmShow(rule._id, rule.Active);
  }

  updateRuleblock() {
    const { updateRule, fetchRules } = this.props

    let body = {};
    body.Active = !this.state.ruleActive

    updateRule(this.state.ruleId, body)
      .then((answer) => {
        fetchRules();
      })
      .catch((error) => {
        console.error(error);
      });

    this.ruleblockConfirmToggle()
  }

  ruleblockConfirmShow(id, active) {
    this.setState({
      ruleblockConfirmShown: true,
      ruleId: id,
      ruleActive: active
    })
  }

  ruleblockConfirmToggle() {
    this.setState({ ruleblockConfirmShown: !this.state.ruleblockConfirmShown })
  }

  handleDeleteRule(ruleId, e) {
    e.stopPropagation(); // Prevent row click navigation

    const { deleteRule, fetchRules } = this.props;

    if (window.confirm('¿Estás seguro de que deseas eliminar esta regla?')) {
      deleteRule(ruleId)
        .then((answer) => {
          fetchRules(); // Refresh the rules list after deletion
        })
        .catch((error) => {
          console.error('Error deleting rule:', error);
        });
    }
  }

  render() {

    return (
      <>
        <div className="rules-list">
          {this.props.rules.map(rule => (
            <div key={rule._id} className="rl-rowcard" onClick={e => this.goTo(rule._id, e)}>
              <div className="rl-rowcard-main">
                <div className="rl-rowcard-name">
                  <i className="fas fa-pencil-ruler"></i>
                  {rule.Name}
                </div>
                <span className={`rl-badge ${rule.Active ? 'success' : 'danger'}`}>
                  <i className={`fas mr-1 ${rule.Active ? 'fa-check' : 'fa-ban'}`}></i>
                  {rule.Active ? 'Activa' : 'Inactiva'}
                </span>
              </div>
              <div className="rl-rowcard-params">
                <div className="rl-param">
                  <span className="rl-label">Tipo</span>
                  <span className="rl-value">{this.getTypeName(rule.Type)}</span>
                </div>
                <div className="rl-param">
                  <span className="rl-label">Días máximos</span>
                  <span className="rl-value">{rule.MaxDays} {rule.MaxDays === 1 ? 'día' : 'días'}</span>
                </div>
                <div className="rl-param">
                  <span className="rl-label">Descuento</span>
                  <span className="rl-value rl-discount">{rule.DiscountPercentage}%</span>
                </div>
                <div className="rl-param">
                  <span className="rl-label">Tipo de taquilla</span>
                  <span className="rl-value">{this.getLockerName(rule.Locker)}</span>
                </div>
                <div className="rl-param rl-param-wide">
                  <span className="rl-label">Condiciones</span>
                  <span className="rl-value rl-condition" title={rule.Condition}>{rule.Condition}</span>
                </div>
                <div className="rl-param">
                  <span className="rl-label">Fecha de creación</span>
                  <span className="rl-value">{(new Date(rule.TimeStamp)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                </div>
              </div>
              <div className="rl-rowcard-actions">
                <button
                  className={`rl-btn ${rule.Active ? 'rl-btn-danger' : 'rl-btn-success'}`}
                  onClick={(e) => this.handleRuleblockClick(rule, e)}
                >
                  <i className={`fas mr-1 ${rule.Active ? 'fa-ban' : 'fa-check'}`}></i>
                  {rule.Active ? 'Deshabilitar' : 'Habilitar'}
                </button>
                <button className="rl-btn rl-btn-edit" onClick={e => this.goTo(rule._id, e)}>
                  <i className="fas fa-edit mr-1"></i>
                  Editar
                </button>
                <button
                  className="rl-btn rl-btn-delete"
                  type="button"
                  onClick={(e) => this.handleDeleteRule(rule._id, e)}
                >
                  <i className="fas fa-trash mr-1"></i>
                  Eliminar
                </button>
              </div>
            </div>
          )
          )}
        </div>
        <div>
          <Modal isOpen={this.state.ruleblockConfirmShown}
            toggle={this.ruleblockConfirmToggle} className="op-modal">
            <ModalHeader toggle={this.ruleblockConfirmToggle}>
              {this.state.ruleActive != null && this.state.ruleActive ?
                (<p className="text-center">Deshabilitar regla</p>) : (<p className="text-center">Habilitar regla</p>)
              }
            </ModalHeader>
            <ModalBody>
              {this.state.ruleActive != null && this.state.ruleActive ?
                (
                  <div className="text-center">
                    <p>¿Estás seguro de deshabilitar la regla?</p>
                    <br></br>
                    <p>-Aunque el agregador la tenga asignada en su ficha esta no será aplicada en el precio.</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <p>¿Estás seguro de habilitar la venta del agregador?</p>
                    <br></br>
                    <p>-Si el agregador la tiene asignada en su ficha esta será aplicada en el precio.</p>
                  </div>
                )
              }
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
              <Button color="info mr-5" onClick={this.updateRuleblock}>
                Confirmar
              </Button>
              <Button color="danger" onClick={this.ruleblockConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  rules: state.rules.rules,
})

const mapDispatchToProps = dispatch => ({
  updateRule: bindActionCreators(updateRule, dispatch),
  fetchRules: bindActionCreators(fetchRules, dispatch),
  deleteRule: bindActionCreators(deleteRule, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RulesList)
